(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxAssignSignInProfileToPrinters(
    $rootScope, NetworkListPaging, EnumerationService, PrinterListService,
    PrinterListPOSTPaging, $timeout, $http, toastr, $filter
  ) {
    return {
      restrict: 'EA',
      scope: {
        signInProfile: '=context',
        tenant: '=tenant',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/signInProfileProperties/assignSignInProfileToPrinters/assignSignInProfileToPrinters.template.html',
      link: function(scope) {


        scope.me = $rootScope.currentUser;
        scope.supportedVendors = EnumerationService.enums.OndeviceSupportedVendor;
        scope.selectingVendor = false;

        var excludedPrinters = [];
        var printerIds = [];

        scope.excludedPrinterPagingObject = new PrinterListPOSTPaging();
        var scrollEnd = null;
        var containerHeight = null;
        scope.printersPageMeta = null;
        scope.printers = [];

        scope.printerPagingObject = new PrinterListPOSTPaging();
        var excludedScrollEnd = null;
        var excludedContainerHeight = null;
        scope.excludedPrintersPageMeta = null;
        scope.excludedPrintersList = [];

        scope.networkPaginationObject = null;
        scope.selectedNetworksFilters = [];
        scope.filters = {
          vendor: null,
          withPrinterCredential: false,
          // installOnPrinters: false,
          networks: [],
          excludePrinters: []
        }

        scope.selectVendor = function () {
          scope.selectingVendor = !scope.selectingVendor;
          scope.networkPaginationObject = null;
        }

        scope.closeSelectVendor = function (vendor) {
          if (vendor) {
            scope.filters.vendor = vendor.id;
            scope.getPrinters();
          } else {
            scope.filters.vendor = null;
          }
          scope.selectingVendor = false;
        }

        scope.selectNetworks = function () {
          scope.networkPaginationObject = new NetworkListPaging();
          scope.selectingVendor = false;
        }

        scope.closeSelectNetworkDialog = function () {
          scope.networkPaginationObject = null;
        }

        scope.toggleNetwork = function (network) {
          if (!scope.selectedNetworksFilters.includes(network)) {
            scope.selectedNetworksFilters.push(network)
            if (!scope.printerPagingObject.pagingCriteria.networks) {
              scope.printerPagingObject.pagingCriteria.networks = [];
            }
            scope.printerPagingObject.pagingCriteria.networks.push(network.info._links.self.href);
            scope.filters.networks.push(network.info._links.self.href);
            scope.getPrinters();
          }
        }

        scope.removeNetworkFilter = function (index, event) {
          event.stopPropagation();
          scope.selectedNetworksFilters.splice(index, 1);
          scope.printerPagingObject.pagingCriteria.networks.splice(index, 1);
          scope.filters.networks.splice(index, 1);
          if (scope.selectedNetworksFilters.length < 1) {
            scope.printerPagingObject.pagingCriteria.networks = null;
          }
          scope.getPrinters();
        }


        scope.excludeThisPrinter = function (printer) {
          if (!excludedPrinters.includes(printer)) {
            excludedPrinters.push(printer)
            setPrinterIds();
          }
        }

        scope.includeThisPrinter = function (event, printer) {
          event.stopPropagation();
          for (var i = 0; i < excludedPrinters.length; i++) {
            if (excludedPrinters[i].info._links.self.href === printer.info._links.self.href) {
              excludedPrinters.splice(i, 1);
              if (excludedPrinters.length > 0) {
                setPrinterIds();
              } else {
                scope.filters.excludePrinters = [];
                scope.excludedPrintersList = [];
                scope.excludedPrintersPageMeta = null;
                printerIds = [];
                scope.getPrinters();
              }
            }
          }
        }


        function setPrinterIds () {
          printerIds = [];
          for (var i = 0; i < excludedPrinters.length; i++) {
            if (!printerIds.includes(excludedPrinters[i].info._links.self.href)) {
              printerIds.push(excludedPrinters[i].info._links.self.href)
            }
          }
          scope.filters.excludePrinters = printerIds;
          getExcludedPrinters();
          scope.getPrinters();
        }

        function getExcludedPrinters () {
          scope.excludedPrinterPagingObject.pagingCriteria.printerIds = printerIds;
          scope.excludedPrinterPagingObject.pagingCriteria.pageSize = 20;
          scope.excludedPrinterPagingObject.pagingCriteria.page = 0;
          scope.excludedPrinterPagingObject.pagingCriteria.includeUnassignedPrinters = null;

          scope.excludedLoading = true;
          PrinterListService.postGetPrinterListPaged(scope.excludedPrinterPagingObject).then(function(printers) {
            scope.excludedPrintersPageMeta = printers.page;
            scope.totalExcludedPages = printers.page.totalPages;
            scope.excludedLoading = false;
            scope.excludedPrintersList = printers.list;
          }).catch(function(error){});
        }

        function getNextExcludedPage () {
          if (!scope.excludedLoading && scope.totalExcludedPages > scope.excludedPrinterPagingObject.pagingCriteria.page + 1) {
            scope.excludedLoading = true;
            scope.excludedPrinterPagingObject.pagingCriteria.page += 1;
            PrinterListService.postGetPrinterListPaged(scope.excludedPrinterPagingObject).then(function(printers){
              if (printers.list) {
                scope.excludedPrintersList = scope.excludedPrintersList.concat(printers.list);
              }
              scope.excludedLoading = false;
            }).catch(function(error){});
          }
        }

        angular.element('.context-printer-list-excluded').on('scroll', function (event) {
          excludedScrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          excludedContainerHeight = event.currentTarget.scrollHeight;

          if (!scope.excludedLoading && scope.totalExcludedPages > scope.excludedPrinterPagingObject.pagingCriteria.page + 1) {
            if (excludedScrollEnd > excludedContainerHeight) {
              $timeout(function() {
                getNextExcludedPage();
              }, 300)
            }
          }
        });

        scope.getPrinters = function() {
          scope.printerPagingObject.pagingCriteria.types = ['NETWORK','VIRTUAL'];
          scope.printerPagingObject.pagingCriteria.pageSize = 20;
          scope.printerPagingObject.pagingCriteria.page = 0;
          scope.printerPagingObject.pagingCriteria.includeUnassignedPrinters = null;
          scope.printerPagingObject.pagingCriteria.excludePrinters = printerIds;
          scope.printerPagingObject.pagingCriteria.vendor = [];
          scope.printerPagingObject.pagingCriteria.vendor[0] = scope.filters.vendor;
          scope.printerPagingObject.pagingCriteria.withPrinterCredential = scope.filters.withPrinterCredential;

          scope.loading = true;

          PrinterListService.postGetPrinterListPaged(scope.printerPagingObject).then(function(printers) {
            scope.printersPageMeta = printers.page;
            scope.totalPages = printers.page.totalPages;
            window.scrollTo(0,0);

            if (printers.list) {
              scope.printers = printers.list;
            } else {
              scope.printers = null;
            }
            scope.loading = false;
          }).catch(function(error){
            scope.loading = false;
          });
        }

        function getNextPage () {
          if (!scope.loading && scope.totalPages > scope.printerPagingObject.pagingCriteria.page + 1) {
            scope.loading = true;
            scope.printerPagingObject.pagingCriteria.page += 1;
            PrinterListService.postGetPrinterListPaged(scope.printerPagingObject).then(function(printers){
              if (printers.list) {
                scope.printers = scope.printers.concat(printers.list);
              }
              scope.loading = false;
            }).catch(function(error){});
          }
        }

        angular.element('.context-printer-list').on('scroll', function (event) {
          scrollEnd = event.currentTarget.clientHeight + event.currentTarget.scrollTop + 1;
          containerHeight = event.currentTarget.scrollHeight;

          if (!scope.loading && scope.totalPages > scope.printerPagingObject.pagingCriteria.page + 1) {
            if (scrollEnd > containerHeight) {
              $timeout(function() {
                getNextPage();
              }, 300)
            }
          }
        });

        scope.submit = function () {
          var url = scope.signInProfile.links['px:assignPrinterCredential'].href;
          $http.post(url, scope.filters).then(function(response) {
            toastr.success($filter('translate')('ChangesSaved'));
            $rootScope.$broadcast('REFRESH_GO_PRINTER_LIST');
          }).catch(function(error){
            toastr.error($filter('translate')('ERROR'))
          });
          scope.callback();
        }
      }
    };
  }

  pxAssignSignInProfileToPrinters.$inject = [
    '$rootScope', 'NetworkListPaging', 'EnumerationService', 'PrinterListService',
    'PrinterListPOSTPaging', '$timeout', '$http', 'toastr', '$filter'
  ];

  angular
    .module('printix-admin')
    .directive('pxAssignSignInProfileToPrinters', pxAssignSignInProfileToPrinters);

})();
